import { prop, compose, converge } from 'ramda';

import { fromProps } from 'app/selectors/props';
import { success } from 'app/features/success/selectors';

const helpCenterBlock = compose(prop('helpCenterBlock'), success);
const isVisible = compose(prop('isVisible'), helpCenterBlock);
const faq = compose(prop('faq'), helpCenterBlock);
const isQuestionOpened = converge(prop, [fromProps('anchor'), faq]);

export { isVisible, faq, isQuestionOpened };
